export const mapAsplProduct = (p) => {
  if (!p || typeof p !== "object") return null;

  let photos = [];
  if (
    p.photoList &&
    typeof p.photoList === "object" &&
    Array.isArray(p.photoList.photo)
  ) {
    photos = p.photoList.photo.map((ph) => ph.url).filter(Boolean);
  }

  const proxy = (url) =>
    `${process.env.REACT_APP_API_URL}asplapi/photo/?url=${encodeURIComponent(
      url
    )}`;

  const stockInfo = Array.isArray(p.stockInfoList?.stockInfo)
    ? p.stockInfoList.stockInfo[0] || {}
    : {};

  return {
    // Identity
    id: p.id || "",
    name: p.name || p.productName || "No Name",
    brand: p.producer || p.brand || "",
    producer: p.producer || "",
    reference: p.reference || "",
    oem: p.reference2 || "",
    tecnum: p.tecnum || "",
    tecidd: p.tecidd || "",

    // Category
    category: p.groupName || "",
    category_id: p.group2 || "",
    groupName: p.groupName || "",

    // Logistics
    deliveryDate: p.expectedDeliveryDate || "",
    tax: p.tax || "",
    currency: p.currency || "USD",

    // Prices (AUTHORITATIVE)
    priceUSD:
      p.price_usd ??
      stockInfo.priceInclTax ??
      null,

    priceEx:
      stockInfo.priceExclTax ??
      null,

    priceNGN:
      p.price_ngn ??
      null,

    exchangeRate:
      p.exchange_rate ??
      null,

    // Stock
    stock: stockInfo.quantityReal || 0,

    // Images
    photos: photos.map(proxy),
    firstPhoto: photos.length ? proxy(photos[0]) : null,

    // Barcodes
    barcodes: Array.isArray(p.barCodeList?.barCode)
      ? p.barCodeList.barCode
      : [],
  };
};
